import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/shared/services/auth.service';
import { map, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'mi-cuenta',
  templateUrl: './mi-cuenta-estudiante.component.html',
  styleUrls: ['./mi-cuenta-estudiante.component.css']
})
export class MiCuentaEstudianteComponent implements OnInit {

  downloadURL: any;
  fire: any;
  archivos: any;

  //Variables para mostrar y ocultar info en HTML 
  cambiarContrasena: number = 0;
  crearContrasena: number = 0;
  modificarFoto: number = 0;
  miCuenta: number = 1;
  historialPagos: number = 0;
  datosFacturacion: number = 0;

  // Datos de Compra:
  compras: any[] = [];
  loaded = 0;

  constructor(
    public authService: AuthService,
    public afAuth: AngularFireAuth,
    public fb: FormBuilder,
    private afs: AngularFirestore,
    private storage: AngularFireStorage,
    private router: Router,
  ) { }

  usuario = JSON.parse(localStorage.getItem('user'));
  nombre = this.usuario.nombreCompleto.split(' ')[0];

  ngOnInit() {
    this.loaded = 1;
    this.getUsuario()
  }
  getUsuario() {
    this.afs.collection("usuarios").doc(this.usuario.uid).ref.get().then((doc) => {
      this.usuario = doc.data()
    })
  }

  guardarUser() {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`usuarios/${this.usuario.uid}`);
    localStorage.setItem('user', JSON.stringify(this.usuario))
    return userRef.update({
      anosExperiencia: this.usuario.anosExperiencia,
      cantCursos: this.usuario.cantCursos,
      displayName: this.usuario.displayName,
      email: this.usuario.email,
      emailVerified: this.usuario.emailVerified,
      empleador: this.usuario.empleador,
      especialidad: this.usuario.especialidad,
      fechaNacimiento: this.usuario.fechaNacimiento,
      fechaRegistro: this.usuario.fechaRegistro,
      genero: this.usuario.genero,
      industria: this.usuario.industria,
      nombreCompleto: this.usuario.nombreCompleto,
      paisActual: this.usuario.paisActual,
      photoURl: this.usuario.photoURL,
      profesion: this.usuario.profesion,
      situacionLaboral: this.usuario.situacionLaboral,
      titulo: this.usuario.titulo,
      uid: this.usuario.uid,
    }).then(() => {
      window.location.reload();
    })
  }

  transform(value: string, args: any[]): string {
    if (!value) { return ''; }
    return value.split(' ')[0];
  }

  onFileSelected(event, campo) {
    var n = Date.now();
    const file = event.target.files[0];
    const filePath = `Usuarios/${n}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`Usuarios/${n}`, file);
    task
      .snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) {
              this.fire = url;
            }
            if (campo == "photoURL") {
              this.usuario.photoURL = url;
            }
          });
        })
      )
      .subscribe(url => {
        if (url) {
        }
      });
  }

  deleteUser() {
    this.authService.deleteUser();
    this.router.navigate(['']);
  }


}
